if($('.in-index').length){
    $(document).ready(function () {
        function mhRemove(){
            $('.blogFeed .news-item').not(":nth-child(-n+5)").remove();
            $('.news-item').each(function(){
                $(this).find('img').attr('src', $(this).find('img').attr('data-src'))
                $(this).find('.description').after('<div class="text-right"><span class="name">Vojtěch Jiříček</span><a href="'+$(this).find('a.title').attr('href')+'">Celý článek</a></div>')
            });
           
        }
        if(sessionStorage.BlogFeed) {
            $('.blogFeed').append(sessionStorage.BlogFeed);
            $('.blogFeed').each(function() {
                const $carouselBlog = $(this);
                const $closestTitleBlog = $carouselBlog.prev('.homepage-group-title');
                $carouselBlog.slick({
                    arrows: true,
                    dots: false,
                    infinite: false,
                    speed: 300,
                    appendArrows: $closestTitleBlog,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    responsive: [
                      
                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 2.1,
                                slidesToScroll: 1,
                                appendArrows: $closestTitleBlog,
                            }
                           
                        
                        },
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 1.1,
                                slidesToScroll: 1,
                                appendArrows: $closestTitleBlog,
                            }
                        }
                ]
                });
          });
              
        } else {
          $.ajax({
            type: "GET",
            dataType: "html",
            timeout: 1e4,
            cache: !0,
            url: "/cache/nase-novinky/",
            success: function(e) {
                var a = shoptet.common.createDocumentFromString(e),
                t = $(a).find("#newsWrapper").html();
                null !== t && ($(".blogFeed").html(t), mhRemove())
            
                sessionStorage.BlogFeed = $(".blogFeed").html();
                }
            })
            .done(function(){
                $('.blogFeed').each(function() {
                    const $carouselBlog = $(this);
                    const $closestTitleBlog = $carouselBlog.prev('.homepage-group-title');
                    $carouselBlog.slick({
                        arrows: true,
                        dots: false,
                        infinite: false,
                        speed: 300,
                        appendArrows: $closestTitleBlog,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        responsive: [
                            {
                                breakpoint: 991,
                                settings: {
                                    slidesToShow: 2.1,
                                    slidesToScroll: 1,
                                    appendArrows: $closestTitleBlog,
                                }
                            },
                            {
                                breakpoint: 767,
                                settings: {
                                    slidesToShow: 1.1,
                                    slidesToScroll: 1,
                                    appendArrows: $closestTitleBlog,
                                }
                            }
                    ]
                    });
              });
            })
        }
    })


    if ($('.video-responsive video').length) {
        $(function() {
          $(".video-responsive video source").each(function() {
            var sourceFile = $(this).attr("data-src");
            $(this).attr("src", sourceFile);
            var video = this.parentElement;
            video.load();
            video.play();
          });
        });
      }
      
      if ($('#background-video').length) {
        document.addEventListener("DOMContentLoaded", function () {
          var video = document.getElementById("background-video");
          video.onloadeddata = function () {
            video.classList.add("loaded");
            $('#background-video').closest('#video-container').find('img').addClass('loaded')
          };
        });
      }
      
}